import ReinsuredTable from 'components/features/reinsured-table';
import HomeLayout from 'layouts/home-layout';
import { useTranslation } from 'react-i18next';

const ReinsuredRecords = () => {
  const { t } = useTranslation();
  return (
    <HomeLayout title={t('reinsured.reinsuredRecords')}>
      <ReinsuredTable />
    </HomeLayout>
  );
};

export default ReinsuredRecords;
